/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import * as moment from 'moment';
export class IdentityWebApiClient {
    constructor(baseUrl, http) {
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    removeUserTag(request) {
        let url_ = this.baseUrl + "/api/commands/RemoveUserTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRemoveUserTag(_response);
        });
    }
    processRemoveUserTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = RemoveUserTagResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addPartnership(request) {
        let url_ = this.baseUrl + "/api/commands/Partnerships/AddPartnership";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddPartnership(_response);
        });
    }
    processAddPartnership(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = AddPartnershipResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updatePartnership(request) {
        let url_ = this.baseUrl + "/api/commands/Partnerships/UpdatePartnership";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdatePartnership(_response);
        });
    }
    processUpdatePartnership(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = UpdatePartnershipResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPartnership(request) {
        let url_ = this.baseUrl + "/api/queries/Partnerships/GetPartnership";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetPartnership(_response);
        });
    }
    processGetPartnership(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = GetPartnershipResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listPartnerships(request) {
        let url_ = this.baseUrl + "/api/queries/Partnerships/ListPartnerships";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListPartnerships(_response);
        });
    }
    processListPartnerships(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListPartnershipsResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCompanyByBuilderCode(builderCode) {
        let url_ = this.baseUrl + "/api/queries/GetCompanyByBuilderCode?";
        if (builderCode === undefined)
            throw new Error("The parameter 'builderCode' must be defined.");
        else if (builderCode !== null)
            url_ += "BuilderCode=" + encodeURIComponent("" + builderCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetCompanyByBuilderCode(_response);
        });
    }
    processGetCompanyByBuilderCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = GetCompanyByBuilderCodeResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCompanyByCode(code) {
        let url_ = this.baseUrl + "/api/queries/GetCompanyByCode?";
        if (code === undefined)
            throw new Error("The parameter 'code' must be defined.");
        else if (code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetCompanyByCode(_response);
        });
    }
    processGetCompanyByCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = GetCompanyByCodeResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCompanyById(id) {
        let url_ = this.baseUrl + "/api/queries/GetCompanyById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetCompanyById(_response);
        });
    }
    processGetCompanyById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = GetCompanyByIdResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserById(request) {
        let url_ = this.baseUrl + "/api/queries/GetUserById";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGetUserById(_response);
        });
    }
    processGetUserById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = GetUserByIdResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listApiClients(request) {
        let url_ = this.baseUrl + "/api/queries/ListApiClients";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListApiClients(_response);
        });
    }
    processListApiClients(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListApiClientsResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listApiScopes(request) {
        let url_ = this.baseUrl + "/api/queries/ListApiScopes";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListApiScopes(_response);
        });
    }
    processListApiScopes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListApiScopesResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listClaimsByUserId(request) {
        let url_ = this.baseUrl + "/api/queries/ListClaimsByUserId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListClaimsByUserId(_response);
        });
    }
    processListClaimsByUserId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListClaimsByUserIdResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listCompaniesByEmailDomain(request) {
        let url_ = this.baseUrl + "/api/queries/ListCompaniesByUserEmailDomain";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListCompaniesByEmailDomain(_response);
        });
    }
    processListCompaniesByEmailDomain(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListCompaniesByUserEmailDomainResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listCompaniesByUserId(request) {
        let url_ = this.baseUrl + "/api/queries/ListCompaniesByUserId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListCompaniesByUserId(_response);
        });
    }
    processListCompaniesByUserId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListCompaniesByUserIdResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listCompanies(request) {
        let url_ = this.baseUrl + "/api/queries/ListCompanies";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListCompanies(_response);
        });
    }
    processListCompanies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListCompaniesResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listCompaniesForViewAs(request) {
        let url_ = this.baseUrl + "/api/queries/ListCompaniesForViewAs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListCompaniesForViewAs(_response);
        });
    }
    processListCompaniesForViewAs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListCompaniesForViewAsResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listRoles(request) {
        let url_ = this.baseUrl + "/api/queries/ListRoles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListRoles(_response);
        });
    }
    processListRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListRolesResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listUsers(request) {
        let url_ = this.baseUrl + "/api/queries/ListUsers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListUsers(_response);
        });
    }
    processListUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListUsersResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    listUsersForViewAs(request) {
        let url_ = this.baseUrl + "/api/queries/ListUsersForViewAs";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processListUsersForViewAs(_response);
        });
    }
    processListUsersForViewAs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = ListUsersForViewAsResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addCompany(request) {
        let url_ = this.baseUrl + "/api/commands/AddCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAddCompany(_response);
        });
    }
    processAddCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = AddCompanyResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    assignUserTag(request) {
        let url_ = this.baseUrl + "/api/commands/AssignUserTag";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAssignUserTag(_response);
        });
    }
    processAssignUserTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = AssignUserTagResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    confirmApiEmail(userId, token) {
        let url_ = this.baseUrl + "/api/commands/ConfirmApiEmail?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === undefined)
            throw new Error("The parameter 'token' must be defined.");
        else if (token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processConfirmApiEmail(_response);
        });
    }
    processConfirmApiEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createApiClient(request) {
        let url_ = this.baseUrl + "/api/commands/CreateApiClient";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateApiClient(_response);
        });
    }
    processCreateApiClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = CreateApiClientResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createUser(request) {
        let url_ = this.baseUrl + "/api/commands/CreateUser";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCreateUser(_response);
        });
    }
    processCreateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = CreateUserResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deleteUserById(request) {
        let url_ = this.baseUrl + "/api/commands/DeleteUserById";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDeleteUserById(_response);
        });
    }
    processDeleteUserById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = DeleteUserByIdResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    registerUser(request) {
        let url_ = this.baseUrl + "/api/commands/RegisterUser";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRegisterUser(_response);
        });
    }
    processRegisterUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = RegisterUserResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    registerUserDetails(request) {
        let url_ = this.baseUrl + "/api/commands/RegisterUserDetails";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRegisterUserDetails(_response);
        });
    }
    processRegisterUserDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = RegisterUserDetailsResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateApiClient(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateApiClient";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateApiClient(_response);
        });
    }
    processUpdateApiClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = UpdateApiClientResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateCompany(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateCompany";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateCompany(_response);
        });
    }
    processUpdateCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = UpdateCompanyResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateCompanyStatus(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateCompanyStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateCompanyStatus(_response);
        });
    }
    processUpdateCompanyStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = UpdateCompanyStatusResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUser(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateUser(_response);
        });
    }
    processUpdateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = UpdateUserResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUserDarkMode(request) {
        let url_ = this.baseUrl + "/api/commands/UpdateUserDarkMode";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUpdateUserDarkMode(_response);
        });
    }
    processUpdateUserDarkMode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        let _mappings = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = UpdateUserDarkModeResponse.fromJS(resultData200, _mappings);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class RemoveUserTagResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RemoveUserTagResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class RemoveUserTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RemoveUserTagRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class AddPartnershipResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.partnership = _data["partnership"] ? Partnership.fromJS(_data["partnership"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AddPartnershipResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["partnership"] = this.partnership ? this.partnership.toJSON() : undefined;
        return data;
    }
}
export class Partnership {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.requesterCompany = _data["requesterCompany"] ? Company.fromJS(_data["requesterCompany"], _mappings) : undefined;
            this.requesterCompanyId = _data["requesterCompanyId"];
            this.requesteeCompany = _data["requesteeCompany"] ? Company.fromJS(_data["requesteeCompany"], _mappings) : undefined;
            this.requesteeCompanyId = _data["requesteeCompanyId"];
            this.approvalId = _data["approvalId"];
            this.approverUserId = _data["approverUserId"];
            this.status = _data["status"];
            this.dateAdded = _data["dateAdded"] ? moment.parseZone(_data["dateAdded"].toString()) : undefined;
            this.addedBy = _data["addedBy"];
            this.dateModified = _data["dateModified"] ? moment.parseZone(_data["dateModified"].toString()) : undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByCompanyId = _data["modifiedByCompanyId"];
            if (Array.isArray(_data["partnershipStatusChanges"])) {
                this.partnershipStatusChanges = [];
                for (let item of _data["partnershipStatusChanges"])
                    this.partnershipStatusChanges.push(PartnershipStatusChange.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Partnership);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requesterCompany"] = this.requesterCompany ? this.requesterCompany.toJSON() : undefined;
        data["requesterCompanyId"] = this.requesterCompanyId;
        data["requesteeCompany"] = this.requesteeCompany ? this.requesteeCompany.toJSON() : undefined;
        data["requesteeCompanyId"] = this.requesteeCompanyId;
        data["approvalId"] = this.approvalId;
        data["approverUserId"] = this.approverUserId;
        data["status"] = this.status;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString(true) : undefined;
        data["addedBy"] = this.addedBy;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString(true) : undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByCompanyId"] = this.modifiedByCompanyId;
        if (Array.isArray(this.partnershipStatusChanges)) {
            data["partnershipStatusChanges"] = [];
            for (let item of this.partnershipStatusChanges)
                data["partnershipStatusChanges"].push(item.toJSON());
        }
        return data;
    }
}
export class Company {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentCompanyId = _data["parentCompanyId"];
            this.code = _data["code"];
            this.builderCode = _data["builderCode"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.postalAddress = _data["postalAddress"] ? Address.fromJS(_data["postalAddress"], _mappings) : undefined;
            this.postalAddressId = _data["postalAddressId"];
            this.streetAddress = _data["streetAddress"] ? Address.fromJS(_data["streetAddress"], _mappings) : undefined;
            this.streetAddressId = _data["streetAddressId"];
            this.website = _data["website"];
            this.addedBy = _data["addedBy"];
            this.modifiedBy = _data["modifiedBy"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Company);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentCompanyId"] = this.parentCompanyId;
        data["code"] = this.code;
        data["builderCode"] = this.builderCode;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["type"] = this.type;
        data["status"] = this.status;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : undefined;
        data["postalAddressId"] = this.postalAddressId;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : undefined;
        data["streetAddressId"] = this.streetAddressId;
        data["website"] = this.website;
        data["addedBy"] = this.addedBy;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}
export var CompanyType;
(function (CompanyType) {
    CompanyType[CompanyType["Builder"] = 0] = "Builder";
    CompanyType[CompanyType["Manufacturer"] = 1] = "Manufacturer";
    CompanyType[CompanyType["Architecture"] = 2] = "Architecture";
})(CompanyType || (CompanyType = {}));
export var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus[CompanyStatus["PendingApproval"] = 0] = "PendingApproval";
    CompanyStatus[CompanyStatus["Approved"] = 1] = "Approved";
    CompanyStatus[CompanyStatus["Rejected"] = 2] = "Rejected";
})(CompanyStatus || (CompanyStatus = {}));
export class Address {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Address);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        return data;
    }
}
export var PartnershipStatus;
(function (PartnershipStatus) {
    PartnershipStatus[PartnershipStatus["Requested"] = 0] = "Requested";
    PartnershipStatus[PartnershipStatus["Cancelled"] = 1] = "Cancelled";
    PartnershipStatus[PartnershipStatus["Denied"] = 2] = "Denied";
    PartnershipStatus[PartnershipStatus["Approved"] = 3] = "Approved";
    PartnershipStatus[PartnershipStatus["Terminated"] = 4] = "Terminated";
    PartnershipStatus[PartnershipStatus["Reconnected"] = 5] = "Reconnected";
})(PartnershipStatus || (PartnershipStatus = {}));
export class PartnershipStatusChange {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.partnershipId = _data["partnershipId"];
            this.status = _data["status"];
            this.changeCompanyId = _data["changeCompanyId"];
            this.dateAdded = _data["dateAdded"] ? moment.parseZone(_data["dateAdded"].toString()) : undefined;
            this.addedBy = _data["addedBy"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, PartnershipStatusChange);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnershipId"] = this.partnershipId;
        data["status"] = this.status;
        data["changeCompanyId"] = this.changeCompanyId;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString(true) : undefined;
        data["addedBy"] = this.addedBy;
        return data;
    }
}
export class AddPartnershipRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.requesterCompanyId = _data["requesterCompanyId"];
            this.requesteeCompanyId = _data["requesteeCompanyId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AddPartnershipRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["requesterCompanyId"] = this.requesterCompanyId;
        data["requesteeCompanyId"] = this.requesteeCompanyId;
        return data;
    }
}
export class UpdatePartnershipResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.partnership = _data["partnership"] ? Partnership.fromJS(_data["partnership"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdatePartnershipResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["partnership"] = this.partnership ? this.partnership.toJSON() : undefined;
        return data;
    }
}
export class UpdatePartnershipRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.termsAndConditionsId = _data["termsAndConditionsId"];
            this.status = _data["status"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdatePartnershipRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["termsAndConditionsId"] = this.termsAndConditionsId;
        data["status"] = this.status;
        return data;
    }
}
export class GetPartnershipResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.partnership = _data["partnership"] ? Partnership.fromJS(_data["partnership"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetPartnershipResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["partnership"] = this.partnership ? this.partnership.toJSON() : undefined;
        return data;
    }
}
export class GetPartnershipRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.partnershipId = _data["partnershipId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetPartnershipRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["partnershipId"] = this.partnershipId;
        return data;
    }
}
export class ListPartnershipsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(SituResponse.fromJS(item, _mappings));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (Array.isArray(_data["partnerships"])) {
                this.partnerships = [];
                for (let item of _data["partnerships"])
                    this.partnerships.push(Partnership.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListPartnershipsResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.partnerships)) {
            data["partnerships"] = [];
            for (let item of this.partnerships)
                data["partnerships"].push(item.toJSON());
        }
        return data;
    }
}
export class SituResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, SituResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class ListPartnershipsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.companyId = _data["companyId"];
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["partnershipStatuses"])) {
                this.partnershipStatuses = [];
                for (let item of _data["partnershipStatuses"])
                    this.partnershipStatuses.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListPartnershipsRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["companyId"] = this.companyId;
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.partnershipStatuses)) {
            data["partnershipStatuses"] = [];
            for (let item of this.partnershipStatuses)
                data["partnershipStatuses"].push(item);
        }
        return data;
    }
}
export class GetCompanyByBuilderCodeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetCompanyByBuilderCodeResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    }
}
export class GetCompanyByCodeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetCompanyByCodeResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    }
}
export class GetCompanyByIdResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetCompanyByIdResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    }
}
export class GetUserByIdResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetUserByIdResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class User {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(Role.fromJS(item, _mappings));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobile = _data["mobile"];
            this.position = _data["position"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [];
                for (let item of _data["tagIds"])
                    this.tagIds.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, User);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["emailConfirmed"] = this.emailConfirmed;
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobile"] = this.mobile;
        data["position"] = this.position;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}
export class Role {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Role);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
export var Position;
(function (Position) {
    Position[Position["Owner"] = 0] = "Owner";
    Position[Position["Director"] = 1] = "Director";
    Position[Position["Manager"] = 2] = "Manager";
})(Position || (Position = {}));
export class GetUserByIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, GetUserByIdRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}
export class ListApiClientsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (Array.isArray(_data["clients"])) {
                this.clients = [];
                for (let item of _data["clients"])
                    this.clients.push(Client.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListApiClientsResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }
}
export class Client {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.enabled = _data["enabled"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.description = _data["description"];
            this.created = _data["created"] ? moment.parseZone(_data["created"].toString()) : undefined;
            this.lastAccessed = _data["lastAccessed"] ? moment.parseZone(_data["lastAccessed"].toString()) : undefined;
            if (Array.isArray(_data["allowedScopes"])) {
                this.allowedScopes = [];
                for (let item of _data["allowedScopes"])
                    this.allowedScopes.push(ClientScope.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Client);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabled"] = this.enabled;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString(true) : undefined;
        data["lastAccessed"] = this.lastAccessed ? this.lastAccessed.toISOString(true) : undefined;
        if (Array.isArray(this.allowedScopes)) {
            data["allowedScopes"] = [];
            for (let item of this.allowedScopes)
                data["allowedScopes"].push(item.toJSON());
        }
        return data;
    }
}
export class ClientScope {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.scope = _data["scope"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ClientScope);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        return data;
    }
}
export class ListApiClientsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListApiClientsRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        return data;
    }
}
export class ListApiScopesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [];
                for (let item of _data["scopes"])
                    this.scopes.push(ClientScope.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListApiScopesResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item.toJSON());
        }
        return data;
    }
}
export class ListApiScopesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListApiScopesRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class ListClaimsByUserIdResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Claim.fromJS(item, _mappings));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListClaimsByUserIdResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class Claim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                this.properties = {};
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties[key] = _data["properties"][key];
                }
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"], _mappings) : undefined;
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, Claim);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}
export class ClaimsIdentity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
            this.name = _data["name"];
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"], _mappings) : undefined;
            this.bootstrapContext = _data["bootstrapContext"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item, _mappings));
            }
            this.label = _data["label"];
            this.nameClaimType = _data["nameClaimType"];
            this.roleClaimType = _data["roleClaimType"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ClaimsIdentity);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["name"] = this.name;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined;
        data["bootstrapContext"] = this.bootstrapContext;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label;
        data["nameClaimType"] = this.nameClaimType;
        data["roleClaimType"] = this.roleClaimType;
        return data;
    }
}
export class ListClaimsByUserIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.userId = _data["userId"];
            this.clientId = _data["clientId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListClaimsByUserIdRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["userId"] = this.userId;
        data["clientId"] = this.clientId;
        return data;
    }
}
export class ListCompaniesByUserEmailDomainResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [];
                for (let item of _data["companies"])
                    this.companies.push(CompanyNameAndId.fromJS(item, _mappings));
            }
            this.defaultCompany = _data["defaultCompany"] ? CompanyNameAndId.fromJS(_data["defaultCompany"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesByUserEmailDomainResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        data["defaultCompany"] = this.defaultCompany ? this.defaultCompany.toJSON() : undefined;
        return data;
    }
}
export class CompanyNameAndId {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CompanyNameAndId);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}
export class ListCompaniesByUserEmailDomainRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesByUserEmailDomainRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class ListCompaniesByUserIdResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [];
                for (let item of _data["companies"])
                    this.companies.push(Company.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesByUserIdResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}
export class ListCompaniesByUserIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesByUserIdRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}
export class ListCompaniesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CompanySummary.fromJS(item, _mappings));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class CompanySummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentCompanyId = _data["parentCompanyId"];
            this.code = _data["code"];
            this.builderCode = _data["builderCode"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.type = _data["type"];
            this.postalAddressId = _data["postalAddressId"];
            this.streetAddressId = _data["streetAddressId"];
            this.status = _data["status"];
            this.userCount = _data["userCount"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CompanySummary);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentCompanyId"] = this.parentCompanyId;
        data["code"] = this.code;
        data["builderCode"] = this.builderCode;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["type"] = this.type;
        data["postalAddressId"] = this.postalAddressId;
        data["streetAddressId"] = this.streetAddressId;
        data["status"] = this.status;
        data["userCount"] = this.userCount;
        return data;
    }
}
export class ListCompaniesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.includeUserCount = _data["includeUserCount"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["includeUserCount"] = this.includeUserCount;
        return data;
    }
}
export class ListCompaniesForViewAsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(Company.fromJS(item, _mappings));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesForViewAsResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class ListCompaniesForViewAsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.search = _data["search"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListCompaniesForViewAsRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["search"] = this.search;
        return data;
    }
}
export class ListRolesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(Role.fromJS(item, _mappings));
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListRolesResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}
export class ListRolesRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListRolesRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}
export class ListUsersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(User.fromJS(item, _mappings));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListUsersResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class ListUsersRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.companyId = _data["companyId"];
            this.role = _data["role"];
            this.emailFilter = _data["emailFilter"];
            this.enabledOnly = _data["enabledOnly"];
            this.includeTags = _data["includeTags"];
            if (Array.isArray(_data["tagFilter"])) {
                this.tagFilter = [];
                for (let item of _data["tagFilter"])
                    this.tagFilter.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListUsersRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["companyId"] = this.companyId;
        data["role"] = this.role;
        data["emailFilter"] = this.emailFilter;
        data["enabledOnly"] = this.enabledOnly;
        data["includeTags"] = this.includeTags;
        if (Array.isArray(this.tagFilter)) {
            data["tagFilter"] = [];
            for (let item of this.tagFilter)
                data["tagFilter"].push(item);
        }
        return data;
    }
}
export class ListUsersForViewAsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(User.fromJS(item, _mappings));
            }
            this.totalItems = _data["totalItems"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListUsersForViewAsResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class ListUsersForViewAsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.companyId = _data["companyId"];
            this.search = _data["search"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, ListUsersForViewAsRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["companyId"] = this.companyId;
        data["search"] = this.search;
        return data;
    }
}
export class AddCompanyResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AddCompanyResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    }
}
export class AddCompanyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.name = _data["name"];
            this.parentCompanyId = _data["parentCompanyId"];
            this.code = _data["code"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.type = _data["type"];
            this.postalAddress = _data["postalAddress"] ? Address.fromJS(_data["postalAddress"], _mappings) : undefined;
            this.streetAddress = _data["streetAddress"] ? Address.fromJS(_data["streetAddress"], _mappings) : undefined;
            this.website = _data["website"];
            this.logoUrl = _data["logoUrl"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AddCompanyRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentCompanyId"] = this.parentCompanyId;
        data["code"] = this.code;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["type"] = this.type;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : undefined;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : undefined;
        data["website"] = this.website;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}
export class AssignUserTagResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AssignUserTagResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class AssignUserTagRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, AssignUserTagRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        return data;
    }
}
export class CreateApiClientResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : undefined;
            this.oneTimeApiKey = _data["oneTimeApiKey"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CreateApiClientResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["oneTimeApiKey"] = this.oneTimeApiKey;
        return data;
    }
}
export class CreateApiClientRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [];
                for (let item of _data["scopes"])
                    this.scopes.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CreateApiClientRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["clientName"] = this.clientName;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}
export class CreateUserResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CreateUserResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class CreateUserRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.isEnabled = _data["isEnabled"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(Role.fromJS(item, _mappings));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobile = _data["mobile"];
            this.position = _data["position"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, CreateUserRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["email"] = this.email;
        data["password"] = this.password;
        data["isEnabled"] = this.isEnabled;
        data["lockoutEnabled"] = this.lockoutEnabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["mobile"] = this.mobile;
        data["position"] = this.position;
        return data;
    }
}
export class DeleteUserByIdResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, DeleteUserByIdResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class DeleteUserByIdRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.builder = _data["builder"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, DeleteUserByIdRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["builder"] = this.builder;
        return data;
    }
}
export class RegisterUserResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.userId = _data["userId"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RegisterUserResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["userId"] = this.userId;
        return data;
    }
}
export class RegisterUserRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.recaptcha = _data["recaptcha"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RegisterUserRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["recaptcha"] = this.recaptcha;
        return data;
    }
}
export class RegisterUserDetailsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RegisterUserDetailsResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
}
export class RegisterUserDetailsRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.companyType = _data["companyType"];
            this.companyWebsite = _data["companyWebsite"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.mobile = _data["mobile"];
            this.position = _data["position"];
            this.postalAddress = _data["postalAddress"] ? Address.fromJS(_data["postalAddress"], _mappings) : undefined;
            this.streetAddress = _data["streetAddress"] ? Address.fromJS(_data["streetAddress"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, RegisterUserDetailsRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["companyType"] = this.companyType;
        data["companyWebsite"] = this.companyWebsite;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobile"] = this.mobile;
        data["position"] = this.position;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : undefined;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : undefined;
        return data;
    }
}
export class UpdateApiClientResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.client = _data["client"] ? Client.fromJS(_data["client"], _mappings) : undefined;
            this.oneTimeApiKey = _data["oneTimeApiKey"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateApiClientResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["client"] = this.client ? this.client.toJSON() : undefined;
        data["oneTimeApiKey"] = this.oneTimeApiKey;
        return data;
    }
}
export class UpdateApiClientRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.disableClient = _data["disableClient"];
            this.deleteClient = _data["deleteClient"];
            this.generateNewApiKey = _data["generateNewApiKey"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateApiClientRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["disableClient"] = this.disableClient;
        data["deleteClient"] = this.deleteClient;
        data["generateNewApiKey"] = this.generateNewApiKey;
        return data;
    }
}
export class UpdateCompanyResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.company = _data["company"] ? Company.fromJS(_data["company"], _mappings) : undefined;
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateCompanyResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["company"] = this.company ? this.company.toJSON() : undefined;
        return data;
    }
}
export class UpdateCompanyRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentCompanyId = _data["parentCompanyId"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.type = _data["type"];
            this.postalAddress = _data["postalAddress"] ? Address.fromJS(_data["postalAddress"], _mappings) : undefined;
            this.streetAddress = _data["streetAddress"] ? Address.fromJS(_data["streetAddress"], _mappings) : undefined;
            this.website = _data["website"];
            this.logoUrl = _data["logoUrl"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateCompanyRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentCompanyId"] = this.parentCompanyId;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["type"] = this.type;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : undefined;
        data["streetAddress"] = this.streetAddress ? this.streetAddress.toJSON() : undefined;
        data["website"] = this.website;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}
export class UpdateCompanyStatusResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateCompanyStatusResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class UpdateCompanyStatusRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.userId = _data["userId"];
            this.status = _data["status"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateCompanyStatusRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["status"] = this.status;
        return data;
    }
}
export class UpdateUserResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"], _mappings) : undefined;
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateUserResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class UpdateUserRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.isEnabled = _data["isEnabled"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(Role.fromJS(item, _mappings));
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobile = _data["mobile"];
            this.position = _data["position"];
            this.id = _data["id"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateUserRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["email"] = this.email;
        data["password"] = this.password;
        data["isEnabled"] = this.isEnabled;
        data["lockoutEnabled"] = this.lockoutEnabled;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["mobile"] = this.mobile;
        data["position"] = this.position;
        data["id"] = this.id;
        return data;
    }
}
export class UpdateUserDarkModeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateUserDarkModeResponse);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}
export class UpdateUserDarkModeRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data, _mappings) {
        if (_data) {
            this.id = _data["id"];
            this.darkMode = _data["darkMode"];
        }
    }
    static fromJS(data, _mappings) {
        data = typeof data === 'object' ? data : {};
        return createInstance(data, _mappings, UpdateUserDarkModeRequest);
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["darkMode"] = this.darkMode;
        return data;
    }
}
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    const mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    let result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
